module.exports = __webpack_public_path__ + "img/ic_redeem.3434647d.svg";